<script>
import NotAuthHeader from "@v2/app/providers/GlobalComponents/layouts/header/NotAuthHeader.vue";
import FeedbackModal from "@/components/Custom/FeedbackModal.vue";
import Footer from "@v2/app/providers/GlobalComponents/layouts/footer/Footer.vue";

export default {
  name: "HelpFormLayout",
  components: { Footer, FeedbackModal, NotAuthHeader }
};
</script>

<template>
  <div>
    <NotAuthHeader simple />
    <div class="help-layout">
      <router-view />
    </div>
    <Footer class="auth-layout__footer" />
    <FeedbackModal />
  </div>
</template>

<style lang="scss" scoped>
@import "@v2/app/styles/media";

.help-layout {
  min-height: 100vh;
  background: url("../../../../../../public/static/images/auth-layout-bg.svg");
  background-size: cover;

  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
